export * from "./formatAnswersWithTextAndImage";
export * from "./adpaterGallery";
export * from "./adapterLink";
export * from "./formatDescription";
export * from "./formatPrice";
export * from "./formatProductTags";
export * from "./formatSlugToText";
export * from "./formatUnicodeText";
export * from "./getCartID";
export * from "./getDiscount";
export * from "./parseHtmlToString";
export * from "./serializeFlatQueryParams";
export * from "./serializeNestedQueryParams";
export * from "./scrollToElement";
